import React, { useEffect, useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime from 'animejs';
import '../css/common.css';
import '../css/button.css';
import ImageButton from '../utils/ImageButton';
import lang from '../lang.json';

const Module4a1 = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module5a1;

    useEffect(() => {
        var tl = anime.timeline({});
        tl.add({
            targets: '#circle1',
            r: 800,
            duration: 2200,
            easing: 'linear',
        }, '0')
            //zoom in the image1
            .add({
                targets: '#img1',
                opacity: 1,
                duration: 8000,
                scale: 8,
                translateX: -100,
                translateY: -25,
                easing: 'easeInOutQuint',
            }, '1500')
            //Fade to image 2
            .add({
                targets: '#img1',
                opacity: 0,
                duration: 1000,
                easing: 'easeInOutQuint',
            }, '8000')
            //Fade in image 2
            .add({
                targets: '#img2',
                opacity: 1,
                duration: 1000,
                easing: 'easeInOutQuint',
            }, '8000')
            //Fade to image 3
            .add({
                targets: '#img2',
                opacity: 0,
                duration: 1000,
                easing: 'easeInOutQuint',
            }, '10000')
            //Fade in image 3
            .add({
                targets: '#img3',
                opacity: 1,
                duration: 1000,
                easing: 'linear',
            }, '10000')
            .add({
                targets: '#circle1',
                r: 0,
                duration: 1,
                easing: 'linear',
            }, '10000')
            .add({
                targets: '#circle2',
                r: 0,
                duration: 1,
                easing: 'linear',
            }, '10000')
            .add({
                targets: '#circle2',
                r: 800,
                duration: 1200,
                easing: 'linear',
            }, '10001')
            //Fade to image 1
            .add({
                targets: '#img3',
                opacity: 0,
                duration: 1000,
                easing: 'easeInOutQuint',
            }, '12000')
            //Fade in image 1
            .add({
                targets: '#img1',
                opacity: 1,
                duration: 1000,
                easing: 'easeInOutQuint',
            }, '12000')
            //Zoom out image 1
            .add({
                targets: '#img1',
                scale: 1,
                translateX: 0,
                translateY: 0,
                duration: 4000,
                easing: 'easeInOutQuint',
            }, '12000')
            //show text
            .add({
                targets: ".t1",
                opacity: 1,
                duration: 1000,
                easing: 'easeOutElastic(1, .8)',
            }, '13000')

        //play a mp3 file
        var audio = new Audio(process.env.PUBLIC_URL + "/assets/sounds/module5a1.mp3");
        audio.play();
        props.audio.push(audio)
    }, []);

    return (<>
        <div className="background" >
            <div style={
                { display: "inline-block", overflow: "hidden", width: 660, height: 500 }} >
                <img src={process.env.PUBLIC_URL + "/assets/images/module5a1/1.jpg"}
                    alt="image"
                    id="img1"
                    style={
                        { position: "relative", left: 0, top: 0 }}
                /> </div> <img src={process.env.PUBLIC_URL + "/assets/images/module5a1/2.jpg"}
                    alt="image"
                    id="img2"
                    style={
                        { position: "absolute", right: 0, top: 0, opacity: 0, width: 660, height: 500 }}
            /> <img src={process.env.PUBLIC_URL + "/assets/images/module5a1/3.jpg"}
                alt="image"
                id="img3"
                style={
                    {
                        position: "absolute",
                        right: 0,
                        top: 0,
                        opacity: 0,
                        width: 660,
                        height: 500,
                        borderSize: 300,
                    }}
            /> <svg viewBox="0 0 660 500" >
                <mask id="circles"
                    maskUnits="objectBoundingBox" >
                    <rect x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        fill="white" />
                    <circle id="circle1"
                        cx="40"
                        cy="40"
                        r="0"
                        fill="black" />
                    <circle id="circle2"
                        cx="140"
                        cy="60"
                        r="0"
                        fill="black" />
                </mask>

                <rect x="0"
                    y="0"
                    width="100%"
                    height="100%"
                    fill="black"
                    style={
                        { mask: 'url(#circles)' }}
                />
            </svg>

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    top: 0,
                    color: 'black',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p
                className='t1'
                style={{
                    position: 'absolute',
                    left: 27,
                    top: 352,
                    color: 'white',
                    fontSize: '15px',
                    width: '600px',
                    opacity: 0,
                }}
            >{texts.lang30}</p>
        </div>
    </>
    );
}

export default Module4a1;